import { render, staticRenderFns } from "./Game_Name.vue?vue&type=template&id=d31de964&scoped=true"
import script from "./Game_Name.vue?vue&type=script&lang=js"
export * from "./Game_Name.vue?vue&type=script&lang=js"
import style0 from "./Game_Name.vue?vue&type=style&index=0&id=d31de964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31de964",
  null
  
)

export default component.exports